module.exports = __webpack_public_path__ + "img/world_sports_news.c9096a0c.jpg";